import { render } from "./QuotaUsage.vue?vue&type=template&id=2d5e021e"
import script from "./QuotaUsage.vue?vue&type=script&lang=js"
export * from "./QuotaUsage.vue?vue&type=script&lang=js"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.2.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__